export default function Node_Middleware() {
  return <div>Node_Middleware Component</div>;
}
